function getVideoService(url: string): VideoService {
  if (url.match(/youtu\.?be/))
    return 'youtube'

  else if (url.includes('vimeo'))
    return 'vimeo'

  else
    throw new Error('Unsupported video service')
}

function getYouTubeVideoId(url: string): string {
  const match = url.match(/(?:\?v=|\/embed\/|\.be\/)([\w-]+)/)

  if (match !== null && match[1] !== undefined) {
    return match[1]
  }
  else {
    throw new Error('Invalid YouTube video URL')
  }
}

function getVimeoVideoID(url: string): string {
  const matchResult = url.match(/\/(?<id>\d+)/)
  const match = matchResult?.groups?.id ?? ''
  if (match === '') {
    throw new Error('Invalid Vimeo video URL')
  }
  return match
}

export function getVideoInformation(url: string): VideoInformation {
  const service = getVideoService(url)
  let id = ''

  if (service === 'youtube') {
    id = getYouTubeVideoId(url)
  }

  if (service === 'vimeo') {
    id = getVimeoVideoID(url)
  }

  return {
    service,
    id,
    url,
    isYoutube: service === 'youtube',
    isVimeo: service === 'vimeo',
  }
}
